export const tr = {
    'id-predictor': "Tahmin ID'si"
};
